import { render, staticRenderFns } from "./AdditemModal.vue?vue&type=template&id=3e9c1047&scoped=true"
import script from "./AdditemModal.vue?vue&type=script&lang=js"
export * from "./AdditemModal.vue?vue&type=script&lang=js"
import style0 from "./AdditemModal.vue?vue&type=style&index=0&id=3e9c1047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9c1047",
  null
  
)

export default component.exports